import { create } from "zustand";

interface UnsavedChangesStore {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (value: boolean) => void;

  pendingNavigation: string | null;
  setPendingNavigation: (path: string | null) => void;

  pendingTab: string | null;
  setPendingTab: (tabKey: string | null) => void;
}

const useUnsavedChangesStore = create<UnsavedChangesStore>((set) => ({
  hasUnsavedChanges: false,
  setHasUnsavedChanges: (value) => set({ hasUnsavedChanges: value }),

  pendingNavigation: null,
  setPendingNavigation(path: string | null) {
    set({
      pendingNavigation: path,
      pendingTab: null,
    });
  },

  pendingTab: null,
  setPendingTab(tab: string | null) {
    set({
      pendingTab: tab,
      pendingNavigation: null,
    });
  },
}));

export default useUnsavedChangesStore;
